module.exports = __webpack_public_path__ + "static/media/Point.c16f0e6a5824934ee2bada026690b36d.svg";